export default {
    entityKey: 'pipelines',
    titles: {
        singular: 'Pipeline',
        plural: 'Pipelines'
    }
}
